import { Subscription } from 'rxjs';

export function unsubscribe(...subscription: Subscription[]): void {
  subscription.filter(i => i != null).forEach(c => c.unsubscribe());
}

// export const EMAIL_REGEX = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';
export const EMAIL_REGEX = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
